// extracted by mini-css-extract-plugin
module.exports = {"video":"dh-dh-klima-spesial-video--94b269c4627a6f8aacd41776f6f47b32","videoElement":"dh-dh-klima-spesial-videoElement--03ac608ff1e0e4bcae6d568160a8d44e"};